import React from 'react';
import PlugSVG from 'components/svg/PlugSVG';
import { useTranslation } from 'react-i18next';

export default function NoResults() {
	const { t } = useTranslation();

	return (
		<div className="hawk-no-results">
			<h1>{t('No Search Results')}</h1>
			<div className="hawk-no-results__box">
				<div className="hawk-no-results__text-column">
					<h2 className="hawk-no-results__heading">{t('Sorry about that!')}</h2>
					<h2 className="hawk-no-results__sub-heading">{t('Your search did not return any results.')}</h2>
					<ul className="hawk-no-results__list">
						<li className="hawk-no-results__list-item">{t('Please double check your spelling.')}</li>
						<li className="hawk-no-results__list-item">
							{t('Try searching for an item that is less specific.')}
						</li>
						<li className="hawk-no-results__list-item">
							{t('You can always narrow your search results later.')}
						</li>
						<li className="hawk-no-results__list-item">
							{t('You can enter a new search topic in the search bar at the top of the page.')}
						</li>
					</ul>
				</div>
				<div className="hawk-no-results__icon-column">
					<PlugSVG class="hawk-no-results__icon" />
				</div>
			</div>
		</div>
	);
}
